import React, { useRef, useState } from "react";
import utils from "../../module/utils";
import { HomeOutlined, BookOutlined, PieChartOutlined, LinkOutlined, DownOutlined } from "@ant-design/icons";
import "./headerNav.scss";
import { NavLink, useLocation } from "react-router-dom";

import { useNavigate } from "react-router";
import Basket from "../../pages/comps/Basket/Basket";

function HeaderNav(props) {
	const headerRef = useRef();

	// const [isTop, updateIsTop] = useState(true); // 判断页面是否向下滚动了

	const [isHome, updateIsHome] = useState(true);
	const location = useLocation();

	const navigate = useNavigate();

	React.useEffect(() => {
		console.log(location.pathname);
		updateIsHome(location.pathname === "/");
		// window.addEventListener("scroll", onScroll);
		// return () => {
		// 	window.removeEventListener("scroll", onScroll);
		// };
	}, []);

	// function onScroll() {
	// 	let topPS = headerRef.current.offsetTop - document.documentElement.scrollTop;
	// 	if (topPS < 0) {
	// 		updateIsTop(false);
	// 	} else {
	// 		updateIsTop(true);
	// 	}
	// }

    const menuItemList = [
        {
            text: "Home",
            icon: <HomeOutlined style={{fontSize: "20px", marginRight: "5px"}} />,
            path: "/"
        },
        // {
        //     text: "Curation",
        //     path: "curation"
        // },
		// {
        //     text: "Search",
        //     path: "search"
        // },
        {
            text: "My Project",
            path: "project"
        },
        // {
        //     text: "Analysis",
        //     path: "analysis"
        // },
        // {
        //     text: "Webserver",
        //     icon: <PieChartOutlined style={{fontSize: "20px", marginRight: "5px"}} />,
        //     path: "#/WebServer",
        //     subMenu: [
        //         {
        //             text: "Signature discovery",
        //             path: "#/WebServer/Analysis"
        //         },
        //         {
        //             text: <span>Response prediction by<br/>TIRSF signatures</span>,
        //             path: "#/WebServer/Application"
        //         },
        //         {
        //             text: "Response prediction by existing signatures",
        //             path: "#/WebServer/Signatures"
        //         }
        //     ]
        // },
        {
            text: "Help",
            icon: <BookOutlined style={{fontSize: "20px", marginRight: "5px"}} />,
            path: "help"
        },
        /* {
            text: "Download",
            icon: <DownloadOutlined style={{fontSize: "20px", marginRight: "5px"}} />,
            path: "#/Download"
        }, */
        // {
        //     text: "Citation",
        //     icon: <LinkOutlined style={{fontSize: "20px", marginRight: "5px"}} />,
        //     path: "citation"
        // },
        {
            text: "Contact",
            icon: <LinkOutlined style={{fontSize: "20px", marginRight: "5px"}} />,
            path: "contact"
        }
    ];

	//点击菜单的回调
	function onClickMenuNew(path) {
		navigate(path);
	}

	return (
		<React.Fragment>
			<div className="headernav-ref" ref={headerRef} />
			{!utils.isHomeBrowseRouter() && <div style={{ height: "64px" }} />}
			<div
				className={
					"headernav-wrap" +
					(location.pathname === "/" && (location.hash === "#home" || location.hash === "")
						? " top-nav-bg"
						: " nav-bg")
				}
			>
				<div className="headernav-logo">
					<img src={`${process.env.PUBLIC_URL}/GEOCuratorLogo.png`} height={30} style={{verticalAlign: "middle", marginRight: "10px"}} />
					GEO-Curator
				</div>
				{menuItemList.map((item, index) => {
					return (
						<NavLink key={index} to={item.path} className="no-style">
							{({ isActive }) => (
								<div
									className={
										"headernav-item-wrap" +
										(location.pathname === "/" &&
										(location.hash === "#home" || location.hash === "")
											? ""
											: " gp-theme-bgcolor") +
										(isActive ? " activated gp-theme-bdcolor-sc gp-theme-color-sc" : "") +
										(item.subMenu ? " has-sub" : "")
									}
								>
									<span>{item.text}</span>
									{item.subMenu && (
										<React.Fragment>
											<span className="headernav-item-sub-icon">
												<DownOutlined
													style={{ fontSize: "12px", marginLeft: "10px" }}
												/>
											</span>
											<div className="headernav-item-sub-menu gp-theme-color-sc">
												{item.subMenu.map((item2, index2) => {
													return (
														<div
															className="headernav-item-sub-menu-item"
															key={index2}
															onClick={() => onClickMenuNew(item2.path)}
														>
															{item2.text}
														</div>
													);
												})}
											</div>
										</React.Fragment>
									)}
								</div>
							)}
						</NavLink>
					);
				})}
				<div
					className={
						"headernav-item-wrap" +
						(location.pathname === "/" && (location.hash === "#home" || location.hash === "")
							? ""
							: " gp-theme-bgcolor")
					}
					// onClick={() => window.open("https://lab.rjmart.cn/10000/RenLab")}
					onClick={() => window.open("https://renlab.org/")}
					key={999}
				>
					{/* item.icon */}
					<span>{"Renlab"}</span>
				</div>
				{/* <Basket/> */}
			</div>
		</React.Fragment>
	);
}

export default HeaderNav;
